module.exports = __webpack_public_path__ + "720_405_boldbanner_03-418ce5d8bba58f7530f694decb664674.png";


//////////////////
// WEBPACK FOOTER
// ./assets/720_405_boldbanner_03.png
// module id = 1124
// module chunks = 1